import { Navbar, Container, Spinner } from "react-bootstrap";
import ProfileDropdown from "../../../common/ProfileDropdown";
import "./Header.css";
import { useGoLive } from "../../../../hooks/school/golive/useGoLive";
import { useState } from "react";
import SuccessModal from "../../../common/SuccessModal";
import toast from "react-hot-toast";
import { useGoLiveContext } from "../../../context/SchoolGoLiveContext/GoLiveContext";
import { useNotification } from "../../../../context/NotificationProvider";
import { useTenantAuth } from "../../../../context/TeanantAuthProvider";
import { useNavigate } from "react-router-dom";

const Header = ({ toggleSidebar, isCollapsed, isMobile }) => {
  const { data, loading, refresh } = useGoLiveContext(); // from context
  const { triggerGoLive, loading: goLiveLoading } = useGoLive();
  const [showModal, setShowModal] = useState(false);
  const { notificationCount } = useNotification();
  const { currentUser } = useTenantAuth();
  const navigate = useNavigate();

  const isSubTenant = currentUser?.auth?.tenant_type === "sub";

  const isLive = data?.has_go_lived;
  const canGoLive = data?.can_go_live;

  const handleGoLiveClick = () => {
    setShowModal(true);
  };

  const handleConfirmGoLive = async () => {
    const res = await triggerGoLive();

    if (res.success) {
      toast.success("Congratulations, you are live now 🎉");
      setShowModal(false);
      refresh();
    } else {
      toast.error(res.message); // now this WILL show
    }
  };

  return (
    <>
      <Navbar
        className={`header ${isCollapsed && !isMobile ? "sidebar-collapsed" : ""}`}
        expand="lg"
      >
        <Container fluid>
          <div className="header-content">
            <button className="sidebar-toggle" onClick={toggleSidebar}>
              <i className="bi bi-list icon-style"></i>
            </button>

            <div className="navbar-header-right">
              {!loading && (canGoLive || isLive) && (
                <div
                  className={`go-live-btn ${isLive ? "live-active" : ""}`}
                  onClick={
                    canGoLive && !isLive && !goLiveLoading
                      ? handleGoLiveClick
                      : undefined
                  }
                  style={{
                    pointerEvents: canGoLive && !isLive ? "auto" : "none",
                  }}
                >
                  {goLiveLoading ? (
                    <Spinner animation="border" size="sm" className="me-2" />
                  ) : (
                    <span className="live-dot"></span>
                  )}
                  <span>
                    {isLive
                      ? "Live"
                      : goLiveLoading
                        ? "Starting..."
                        : "Go Live"}
                  </span>
                </div>
              )}

              {isSubTenant && (
                <div
                  className="notification-bell me-3 position-relative"
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/school-admin/notifications?tab=unread")}
                >
                  <i className="fa-solid fa-bell" style={{ fontSize: "20px", color: "#ffffff" }}></i>
                  {notificationCount > 0 && (
                    <span
                      style={{
                        position: "absolute",
                        top: "-8px",
                        right: "-5px",
                        backgroundColor: "#0d6efd",
                        color: "white",
                        borderRadius: "50%",
                        padding: "2px 6px",
                        fontSize: "8px",
                      }}
                    >
                      {notificationCount}
                    </span>
                  )}
                </div>
              )}

              <ProfileDropdown menuItems={[]} loginRedirectPath="/login" />
            </div>
          </div>
        </Container>
      </Navbar>

      <SuccessModal
        type="confirmation"
        showModal={showModal}
        handleClose={() => setShowModal(false)}
        title="Confirm Go Live"
        message="You are about to start the live session. Once started, this feature cannot be reverted. Are you sure you want to proceed?"
        primaryButtonText="Go Live"
        secondaryButtonText="Cancel"
        onPrimaryClick={handleConfirmGoLive}
        onSecondaryClick={() => setShowModal(false)}
      />
    </>
  );
};

export default Header;
